module.exports = __webpack_public_path__ + "img/icon-sent.88f414ce.svg";